import { __decorate, __metadata } from "tslib";
import _ from 'lodash';
import { Vue, Component, Inject } from 'vue-property-decorator';
import PtSelectLanguage from '@patsnap-biz/select-language';
import '@patsnap-biz/select-language/lib/style';
import '@patsnap-biz/header/lib/style';
import Alert from 'library-components/components/Alert/Alert.vue';
import { Tooltip } from 'element-ui';
import { E_LoginPanelTab } from './types';
import { registerUrlParamKeys } from 'library-components/apis/register/register.type';
import { getAlertDataByCode } from 'library-components/config/alertMsg';
import { getVar, getAllVarsForLogin, postVar } from 'library-components/utils/environment';
import { setLoginLocaleStatus, getLoginLocaleStatus, removeLoginLocaleStatus } from 'library-components/services/localStorage';
import { setLangValue } from 'library-components/utils/langUtils';
import { goToMoudle } from '@/infrastructure/utils/goToMoudle';
import { checkSessionApi, preLogoutApi } from 'library-components/apis/login/login';
import defer from 'library-components/startup/defer';
import { PASSPORT_CLIENT_ID, PASSPORT_CLIENT_NAME, } from 'library-components/config/envConfig';
import { applyAuthInterceptor } from 'library-components/config/authInterceptor';
import { E_PROJECT_NAME } from 'library-components/config/types';
import { makeLanguages } from '@/infrastructure/utils/lang';
import { INCITATION_CODE_TYPE } from 'library-components/apis/type';
import { browserChecker } from 'library-components/utils/browser-checker';
let LoginPanelImpl = class LoginPanelImpl extends Vue {
    constructor() {
        super(...arguments);
        this.E_LoginPanelTab = E_LoginPanelTab;
        this.languages = makeLanguages(this.$i18n.locale);
        // #region 错误相关
        this.showAlert = false;
        this.alertType = 'error';
        this.alertTitle = '';
        this.alertContent = '';
        this.smallScreenClass = '';
        this.isLogin = false;
    }
    onLanguageChange(language) {
        setLangValue(language, false).then(() => {
            setLoginLocaleStatus();
            window.location.reload();
        });
    }
    onAlert(payload) {
        const { type, title, content, } = payload;
        this.alertType = type;
        this.alertTitle = title;
        this.alertContent = content;
        this.showAlert = true;
    }
    onPassportError(payload) {
        const { errcode, email, loginUrl, message, } = payload;
        this.initAlert(errcode, email, loginUrl, message);
    }
    initAlert(errcode = '', email = '', loginUrl = '', message = '') {
        /**
         * errorCode 错误码
         * code 成功提示来自passport
         * error_msg  错误提示 来自passport
         * oaType: oa打开来源： 钉钉(dingtalk) || 企业微信(wechat-enterprise) || 飞书(feishu)...
         */
        errcode = errcode || getVar('errorCode');
        email = email || getVar('email');
        const code = getVar('code');
        const errorMsg = getVar('error_msg') || message;
        const oaType = getVar('oaType');
        const errorVars = getVar('errorVars');
        let account = '';
        if (errorVars) {
            account = ` (${errorVars}) `;
        }
        let type = 'error';
        if (!errcode && code) {
            type = 'success';
        }
        const urlData = getAllVarsForLogin(['from', 'redirect_uri', 'client_id', ...registerUrlParamKeys]);
        const paramsUrl = postVar({ ...urlData });
        let { msg, title } = getAlertDataByCode({
            code: errcode || code,
            lang: this.$i18n.locale,
            serviceArea: _.get(this.commonService, 'Region', '').toLocaleLowerCase(),
            userEmail: email,
            loginUrl,
            paramsUrl,
            account,
        });
        if (message) {
            msg = errorMsg;
            title = '';
        }
        if (msg) {
            if (oaType) {
                msg = msg.replace('{OA}', this.mapperLocalOa(oaType, this.$i18n.locale));
            }
            this.onAlert({
                type,
                title,
                content: msg,
            });
        }
    }
    resetAlert() {
        this.alertTitle = '';
        this.alertContent = '';
        this.showAlert = false;
    }
    mapperLocalOa(oa, lang) {
        const data = {
            dingtalk: {
                en: 'DingTalk',
                cn: '钉钉',
                tw: '釘釘',
                jp: 'DingTalk',
            },
            'wechat-enterprise': {
                en: 'WeCome',
                cn: '企业微信',
                tw: '企業微信',
                jp: 'WeChat Work',
            },
            feishu: {
                en: 'Feishu',
                cn: '飞书',
                tw: '飛書',
                jp: 'FEISHU',
            },
        };
        const detail = _.get(data[oa], lang, '');
        return detail;
    }
    // #endregion
    async onLoginSuccess(opts) {
        const localeChanged = getLoginLocaleStatus();
        if (localeChanged) {
            try {
                await setLangValue(this.$i18n.locale, true).then(() => {
                    removeLoginLocaleStatus();
                });
            }
            catch (error) {
                console.log(error);
            }
        }
        await goToMoudle(opts);
    }
    get componentName() {
        if (this.commonService.InvitationCompanyId ||
            this.commonService.InvitationSortCode ||
            this.commonService.InviterId ||
            this.commonService.invitationSortCodeType === INCITATION_CODE_TYPE.FREE) {
            return () => import('../Invitation/Invitation.vue');
        }
        else {
            return () => import('../LoginTab/LoginTab.vue');
        }
    }
    // #region 杂项
    get CopyrightEndYear() {
        return new Date().getFullYear();
    }
    get CompanyName() {
        const { company_name, } = _.get(this.commonService, 'globalData');
        return company_name;
    }
    get ClientInfo() {
        const { company_name, request_ip, } = _.get(this.commonService, 'globalData');
        const infos = _.filter([company_name, request_ip], info => {
            return !_.isEmpty(info);
        });
        return _.join(infos, ', ');
    }
    // #endregion
    mounted() {
        this.initAlert();
    }
    async created() {
        if (window.innerWidth <= 820) {
            this.smallScreenClass = 'login-screen-between-640-820';
        }
        if (window.innerWidth <= 640) {
            this.smallScreenClass = 'login-screen-less-than-640';
        }
        const client_id = getVar('client_id') || PASSPORT_CLIENT_ID;
        const from = getVar('from') || PASSPORT_CLIENT_NAME;
        const sessionRes = await checkSessionApi({
            from,
            response_type: 'TOKEN',
            client_id,
            flag: from,
        });
        // 检查登录状态
        if (sessionRes.token) {
            this.isLogin = true;
            applyAuthInterceptor(sessionRes.token);
            this.loginService.loginStatus = true;
            if (!(this.commonService.InvitationCompanyId ||
                this.commonService.InvitationSortCode ||
                this.commonService.InviterId)) {
                await goToMoudle();
            }
            return;
        }
        else {
            if (this.commonService.IsInvitationSortCodeLink) {
                this.commonService.goToPublicInvitationPage();
                return;
            }
            this.loginService.loginStatus = false;
        }
        const thirdParty = {
            lang: this.$i18n.locale,
            sentry: {
                companyId: _.get(this.commonService, 'globalData.encrypt_id', ''),
            },
        };
        if (_.get(this.commonService, 'Region') === 'CN') {
            _.set(thirdParty, 'qiyu', {});
        }
        else {
            _.set(thirdParty, 'zendesk', {});
        }
        defer(Vue, E_PROJECT_NAME.Login, {
            thirdParty,
        });
        browserChecker(this.$i18n.locale, E_PROJECT_NAME.Login);
        await preLogoutApi();
    }
};
__decorate([
    Inject('commonService'),
    __metadata("design:type", Object)
], LoginPanelImpl.prototype, "commonService", void 0);
__decorate([
    Inject('loginService'),
    __metadata("design:type", Object)
], LoginPanelImpl.prototype, "loginService", void 0);
LoginPanelImpl = __decorate([
    Component({
        name: 'LoginPanel',
        components: {
            Alert,
            PtSelectLanguage,
            ELTooltip: Tooltip,
        },
    })
], LoginPanelImpl);
export { LoginPanelImpl };
